<template>
  <div class="rates-div mt-8" v-if="rates.length > 0">
    <div class="container">
      <div class="_title">
        <div class="label-div">
          <i class="mdi mdi-circle"></i>&nbsp;
          {{ $t('our-clients-rates') }}
        </div>
        <h1>{{ homeSetting.services_title }}</h1>
        <span v-html="homeSetting.services_description"></span>
      </div>

      <div class="row" v-if="rates.length > 0">
        <div style="direction: rtl;">
          <carousel v-bind="options">
            <slide class="slide-item" v-for="rate in rates" :key="rate.id">
              <div class="rate-item">
                <h1>{{ rate.comment }}</h1>
                <div class="user-info">
                  <img class="img-fluid" :src='rate.member_image' :alt="rate.member_name">
                  <div class="user-name">
                    <h6>{{ rate.member_name }}</h6>
                    <img v-for="j in 5" :key="j" class="img-fluid"
                         :src="'/img/newMainPage/'+(j <= rate.rate ? 'star-fill.png' : 'star-empty.png')"
                         alt="star icon">
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["homeSetting", "rates"],
  data() {
    return {
      options: {
        loop: true,
        margin: 5,
        perPage: 1,
        center: false,
        autoplay: true,
        autoplayTimeout: 3000,
        paginationEnabled: false,
        autoplayHoverPause: true,
        navigationEnabled: true,
        paginationColor: "#555",
        paginationActiveColor: "#9f762b",
        paginationSize: 1,
        rtl: true,
        perPageCustom: [
          [0, 1]
        ],
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.rates-div {
  background: url("../../../public/img/newMainPage/rates-bg.png") center no-repeat, linear-gradient(232deg, #000 3.41%, #1F1F1F 43.76%, #000 96.59%);
  padding: 70px 0;
  position: relative;

  ._title {
    margin-bottom: 35px;

    h1 {
      color: #F4F4F4;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 48px;
      margin-bottom: 16px;
    }

    span {
      color: #F4F4F4;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
  }

  @media (max-width: 768px) {
    ._title {
      margin-bottom: 0;

      h1 {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }

  .rate-item {
    margin-top: 32px;

    h1 {
      color: #F4F4F4;
      text-align: center;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 40px;
      width: 50%;
      margin: 0 auto;

      display: -webkit-box;
      -webkit-line-clamp: 2; /* limit to 2 lines */
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .user-info {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: start;
      gap: 16px;
      margin-top: 48px;

      img {
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 50%;
      }

      .user-name {
        h6 {
          color: #F4F4F4;
          font-size: 24px;
          font-style: normal;
          font-weight: 500;
          line-height: 32px;
        }

        img {
          width: 30px;
          height: 30px;
          object-fit: contain;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .rate-item {
      h1 {
        font-size: 24px;
        line-height: 32px;
        width: 100%;
      }

      .user-info {
        gap: 8px;

        img {
          width: 54px;
          height: 54px;
        }

        .user-name {
          h6 {
            font-size: 16px;
            line-height: 24px;
          }

          img {
            width: 21px;
            height: 21px;
          }
        }
      }
    }
  }
}
</style>
<style>
.rates-div .VueCarousel-navigation {
  top: 25%;
  bottom: unset;
}

.rates-div .VueCarousel-navigation-button {
  border-radius: 12px;
  border: 1px solid #F4F4F4 !important;
  background: #F4F4F4 !important;
  height: 40px;
}

.rates-div .VueCarousel-navigation-button:hover {
  background: #090909 !important;
}

.rates-div .VueCarousel-navigation-next:after,
.rates-div .VueCarousel-navigation-prev:after {
  line-height: 20px;
}

.rates-div .VueCarousel-navigation-next:hover:after,
.rates-div .VueCarousel-navigation-prev:hover:after {
  color: #F4F4F4 !important;
  background-color: #090909 !important;
}

.rates-div .VueCarousel-navigation-next {
  right: 5% !important;
}

.rates-div .VueCarousel-navigation-prev {
  left: 5% !important;
}
</style>